<template>
    <div
        v-if="hasCustomers"
        class="ask-pendo-next-actions">
        <div class="ask-pendo-next-actions__header">
            <h4 class="ask-pendo-next-actions__title">
                {{ $t('askPendo.nextActions.Title') }}
            </h4>
        </div>
        <div class="ask-pendo-next-actions__actions">
            <component
                :is="action"
                v-for="action in actions"
                :key="action"
                :conversation-id="conversationId"
                :customers="customers" />
        </div>
    </div>
</template>

<script>
import get from 'lodash/get';
import isEmpty from 'lodash/isEmpty';
import { mapGetters } from 'vuex';
import CreateSegmentAction from '../next-actions/components/create-segment-action.vue';
import CreateGuideAction from '../next-actions/components/create-guide-action.vue';
import DownloadCsvAction from '../next-actions/components/download-csv-action.vue';

export default {
    name: 'AskPendoNextActions',
    components: { CreateSegmentAction, CreateGuideAction, DownloadCsvAction },
    props: {
        conversationId: {
            type: String,
            required: true,
        },
    },
    data () {
        return {
            actions: ['CreateSegmentAction', 'CreateGuideAction', 'DownloadCsvAction'],
        };
    },
    computed: {
        ...mapGetters('askPendo', ['conversationById']),
        conversation () {
            return this.conversationById(this.conversationId);
        },
        customers () {
            return get(this.conversation, 'state_details.cf_customers', {});
        },
        hasCustomers () {
            return !isEmpty(this.customers);
        },
    },
};
</script>

<style scoped lang="less">
.ask-pendo-next-actions {
    display: grid;
    grid-template-columns: auto 1fr;
    align-items: center;
    gap: 16px;
    padding: 12px 16px;
    background: var(--palette-gray-0);
    border: 1px solid var(--palette-gray-30);
    border-radius: 8px;
    box-shadow: 0 1px 2px var(--semantic-drop-shadow-base);

    &__header {
        display: grid;
        gap: 2px;
    }

    &__title {
        margin: 0;
        color: var(--palette-gray-100);
        font-size: 14px;
        line-height: 20px;
        font-weight: 600;
    }

    &__actions {
        display: grid;
        grid-template-columns: 1fr;
        gap: 12px;
    }

    &__item {
        display: grid;
        grid-template-columns: 1fr 120px;
        align-items: center;
        gap: 12px;
    }

    &__item-text {
        display: grid;
        gap: 2px;
        min-width: 0;
    }

    &__item-title {
        color: var(--palette-gray-100);
        font-weight: 600;
        font-size: 13px;
        line-height: 18px;
    }

    &__item-subtitle {
        color: var(--palette-gray-70);
        font-size: 12px;
        line-height: 18px;
    }
}
</style>
